import { createAsyncThunk } from '@reduxjs/toolkit';
import { getCustomersByBusinessId } from '../services/getCustomersByBusinessId.service';
import { selectSelectedProject } from 'store/projects/selectors/projectsSelectors';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';

export const loadCustomersBySelectedProjectBusinessId = createAsyncThunk(
  'customers/loadCustomersBySelectedProjectBusinessId',
  async (_, { getState }) => {
    const state = getState();

    const activeEmployerInfo = selectUserActiveEmployerInfo(state);

    const selectedProject = selectSelectedProject(state);
    const businessId = selectedProject?.business_id;

    const response = await getCustomersByBusinessId(businessId, activeEmployerInfo);
    return response;
  }
);
